<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Vendas
            <el-button icon="fa fa-download"
              :loading="btnLoading"
              style="font-size: 1em; float: right"
              @click="reportSale()"
              circle></el-button>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtroSale = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; margin-right: 15px; float: right;"></el-button>
          </h4>
          <div class="card-body" style="font-size: 0.8rem">Resultados: {{totalResultsSales}}</div>
        </div>
      </card>
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Movimentos
            <el-button icon="fa fa-download"
              :loading="btnLoading"
              style="font-size: 1em; float: right"
              @click="reportMov()"
              circle></el-button>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtroMov = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; margin-right: 15px; float: right;"></el-button>
          </h4>
          <div class="card-body" style="font-size: 0.8rem">Resultados: {{totalResultsMovements}}</div>
        </div>
      </card>
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Receitas
            <el-button icon="fa fa-download"
              :loading="btnLoading"
              style="font-size: 1em; float: right"
              @click="reportBalance()"
              circle></el-button>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtroBalance = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; margin-right: 15px; float: right;"></el-button>
          </h4>
          <div class="card-body" style="font-size: 0.8rem">Resultados: {{totalResultsBalance}}</div>
        </div>
      </card>
      <!-- Filtro Vendas -->
      <el-dialog center :visible.sync="filtroSale" title="Filtros">
        <card class="row">
          <div class="col-sm-12">
            <label class="col-sm-6">Cliente</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="client"
            >
              <el-option
                v-for="option in clientName"
                class="select-danger"
                :value="option.id"
                :label="option.first_name + ' ' + option.last_name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12" style="margin-top: 10px">
            <label class="col-sm-6">Status</label>
              <el-autocomplete
                class="select-default col-sm-12"
                v-model="statusSale"
                :fetch-suggestions="querySearchAsync"
                placeholder="Comece a digitar para pesquisar"
                @select="handleSelect"
              ></el-autocomplete>
          </div>
          <div class="col-sm-12" style="margin-top: 10px">
            <label class="col-sm-6">Maquina</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="vendMachine"
            >
              <el-option
                v-for="maq in machine"
                class="select-danger"
                :value="maq.id"
                :label="maq.location"
                :key="maq.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-11" style="margin-top: 10px">
            <label class="col-sm-6">Periodo</label>
            <el-date-picker
              style="margin-left: 15px"
              v-model="date_init"
              type="daterange"
              format="dd/MM/yyyy"
              align="right"
              unlink-panels
              range-separator="a"
              start-placeholder="Data de início"
              end-placeholder="Data final">
            </el-date-picker>
          </div>
        </card>
        <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
        <button class="btn btn-success" @click="filtragemSale()">Filtrar</button>
      </el-dialog>
        <!-- Filtro de movimentos -->
      <el-dialog center :visible.sync="filtroMov" title="Filtros">
        <card class="row">
          <div class="col-sm-12">
            <label class="col-sm-6">Produtos</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="produto"
            >
              <el-option
                v-for="option in productsName"
                class="select-danger"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12" style="margin-top: 10px">
            <label class="col-sm-6">Tipo</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="tipo"
            >
              <el-option
                v-for="tipo in movimentos"
                class="select-danger"
                :value="tipo.value"
                :label="tipo.label"
                :key="tipo.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12" style="margin-top: 10px">
            <label class="col-sm-6">Maquina</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="vendMachine"
            >
              <el-option
                v-for="maq in machine"
                class="select-danger"
                :value="maq.id"
                :label="maq.location"
                :key="maq.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-11" style="margin-top: 10px">
            <label class="col-sm-6">Periodo</label>
            <el-date-picker
              style="margin-left: 15px"
              v-model="date_init"
              type="daterange"
              format="dd/MM/yyyy"
              align="right"
              unlink-panels
              range-separator="a"
              start-placeholder="Data de início"
              end-placeholder="Data final">
            </el-date-picker>
          </div>
        </card>
        <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
        <button class="btn btn-success" @click="filtragemMov()">Filtrar</button>
      </el-dialog>
      <!-- Filtro Balance -->
      <el-dialog center :visible.sync="filtroBalance" title="Filtros">
        <card class="row">
          <div class="col-sm-12">
            <label class="col-sm-6">Cliente</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="client"
            >
              <el-option
                v-for="option in clientName"
                class="select-danger"
                :value="option.id"
                :label="option.first_name + ' ' + option.last_name"
                :key="option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12" style="margin-top: 10px">
            <label class="col-sm-6">Status</label>
              <el-autocomplete
                class="select-default col-sm-12"
                v-model="statusSale"
                :fetch-suggestions="querySearchAsync"
                placeholder="Comece a digitar para pesquisar"
                @select="handleSelect"
              ></el-autocomplete>
          </div>
          <div class="col-sm-12" style="margin-top: 10px">
            <label class="col-sm-6">Maquina</label>
            <el-select
              class="select-default col-sm-12"
              size="large"
              placeholder="Selecione"
              v-model="vendMachine"
            >
              <el-option
                v-for="maq in machine"
                class="select-danger"
                :value="maq.id"
                :label="maq.location"
                :key="maq.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-11" style="margin-top: 10px">
            <label class="col-sm-6">Periodo</label>
            <el-date-picker
              style="margin-left: 15px"
              v-model="date_init"
              type="daterange"
              format="dd/MM/yyyy"
              align="right"
              unlink-panels
              range-separator="a"
              start-placeholder="Data de início"
              end-placeholder="Data final">
            </el-date-picker>
          </div>
        </card>
        <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
        <button class="btn btn-success" @click="filtragemBalance()">Filtrar</button>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { 
  Button,
  Dialog, 
  Select, 
  Option, 
  Loading, 
  Autocomplete, 
  DatePicker,
  TimeSelect, } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    
  },
  data() {
    return {
      filtroMov: false,
      filtroSale: false,
      filtroBalance: false,
      loading: true,
      btnLoading: false,
      machines: [],
      tipo: [],
      produto: [],
      customers: [],
      sales: [],
      previousPage: "",
      nextPage: "",
      statusSale: '',
      client: [],
      vendMachine: [],
      date_init: [],
      companyList: [],
      totalResultsSales: 1,
      totalResultsMovements: 1,
      totalResultsBalance: 1,
      links: [],
      state: '',
      timeout:  500,
      pesquisaSale: '',
      pesquisaMov: '',
      pesquisaBalance: '',
      page: 1,
      sord: '',
      pageSize: 1,
      order: false,
    };
  },
  created() {
  },
  mounted() {
    this.getData()
  },
  computed: {
    machine() {
      var seenLocation = {};
      var fil = this.$store.state.machines.machines.filter(function(
        currentObject
      ) {
        if (currentObject.location in seenLocation) {
          return false;
        } else {
          seenLocation[currentObject.location] = true;
          return true;
        }
      });
      return fil;
    },
    clientName() {
      var seenNumber = {};

      var fil = this.$store.state.customers.customers.filter(function(
        currentObject
      ) {
        if (currentObject.email in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.email] = true;
          return true;
        }
      });
      return fil;
    },
    productsName() {
      return this.$store.state.products.products;
    },
    movimentos() {
      return [{ value: "E", label: "Entrada" }, { value: "S", label: "Saida" }];
    },
  },
  methods: {
    getData() {
      this.$store.dispatch("sales/listSort", {sort: '?page_size=' + this.pageSize
                            + this.pesquisaSale}).then(resp => {
        this.totalResultsSales = this.$store.state.sales.page.count 
      })
      this.$store.dispatch("sales/listSortB", {sort: '?page_size=' + this.pageSize
                            + this.pesquisaBalance}).then(resp => {
        this.totalResultsBalance = this.$store.state.sales.pageB.count 
      })
        .then(() => this.$store.dispatch("machines/list"))
        .then(() => {
          this.$store.dispatch("customers/list")
        }).catch(err => console.log(err));
      this.$store.dispatch("movements/listSort", {sort: '?page_size=' + this.pageSize
                            + this.pesquisaMov}).then(resp => {
        this.totalResultsMovements = this.$store.state.movements.page.count
      })
      this.$store.dispatch("products/list").then(() => {
        console.log('store', this.$store.state)
        }).catch(err => console.log(err));
    },
    querySearchAsync(queryString, cb) {
      var y
      this.$store.dispatch("sales/listSort", {sort: '?status__icontains=' + queryString}).then(data => {
        var x = data.results.map(v => {
          let value, link
          if (v.status) {
            value = v.status
          }
          link = value
          return {...v, value, link}
          
        })
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results
        
        results = queryString ? links.filter(this.createFilter(queryString)) : links;
      
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },
    handleSelect(item) {
      this.statusSale = item.status
      console.log('selec', item);
    },
    redux(x) {
      var seenNumber = {};

      var fil = x.filter(function(
        currentObject
      ) {
        if (currentObject.status in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.status] = true;
          return true;
        }
      });
      return fil;
    },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    filtragemSale() {
      this.loading = true
      var date = []
      this.pesquisaSale = ''

      if (this.client) {
        this.pesquisaSale = this.pesquisaSale + "&customer=" + this.client
      }
      if (this.statusSale) {
        this.pesquisaSale = this.pesquisaSale + "&status=" + this.statusSale
      }
      if (this.vendMachine) {
        this.pesquisaSale = this.pesquisaSale + "&vm=" + this.vendMachine
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisaSale = this.pesquisaSale + '&updated__range=' + date[0] + '%2C' + date[1]
      }
      this.getData()

      this.filtroSale = false;
    },
    filtragemMov () {
      this.movements = this.movementsAPI
      var date = []
      this.pesquisaMov = ''

      if (this.produto) {
        this.pesquisaMov = this.pesquisaMov + '&product=' + this.produto
      }
      if (this.tipo) {
        this.pesquisaMov = this.pesquisaMov + "&movement_type=" + this.tipo
      }
      if (this.vendMachine) {
        this.pesquisaMov = this.pesquisaMov + "&vm=" + this.vendMachine
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisaMov = this.pesquisaMov + '&created__range=' + date[0] + '%2C' + date[1]
      }
      this.getData()
      this.filtroMov = false;
    },
    filtragemBalance() {
      this.loading = true
      var date = []
      this.pesquisaBalance = ''

      if (this.client) {
        this.pesquisaBalance = this.pesquisaBalance + "&customer=" + this.client
      }
      if (this.statusSale) {
        this.pesquisaBalance = this.pesquisaBalance + "&status=" + this.statusSale
      }
      if (this.vendMachine) {
        this.pesquisaBalance = this.pesquisaBalance + "&vm=" + this.vendMachine
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisaBalance = this.pesquisaBalance + '&updated__range=' + date[0] + '%2C' + date[1]
      }
      this.getData()

      this.filtroBalance = false;
    },
    clearFiltro() {
      this.client = "";
      this.statusSale = "";
      this.vendMachine = "";
      this.produto = '',
      this.tipo = '',
      this.pesquisaSale = ''
      this.pesquisaMov = ''
      this.pesquisaBalance = ''
      this.date_init = []
      this.getData();
      this.filtroSale = false
      this.filtroMov = false
      this.filtroBalance = false
    },
    reportSale() {
      if (this.totalResultsSales > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResultsSales + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        this.pesquisaSale = this.pesquisaSale.replace('&','?')
        this.$store.dispatch('general/excelSell', {search: this.pesquisaSale}).then(data => {
          this.btnLoading = data
        })
      }
    },
    reportMov() {
      if (this.totalResultsMovements > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResultsMovements + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        this.pesquisaMov = this.pesquisaMov.replace('&','?')
        this.$store.dispatch('general/excelMovement', {search: this.pesquisaMov}).then(data => {
          this.btnLoading = data
        })
      }
    },
    reportBalance() {
      if (this.totalResultsBalance > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResultsBalance + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        this.pesquisaBalance = this.pesquisaBalance.replace('&','?')
        this.$store.dispatch('general/excelBalance', {search: this.pesquisaBalance}).then(data => {
          this.btnLoading = data
        })
      }
    },
  },
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
#linha {
  width: 100%;
  border-bottom: 1px solid #c5c0c0;
}
.card .card-body {
    padding: 5px 0px 1px 1px;
}
.card .card-body[data-v-8a391d2a] {
    padding: 5px 1px 5px 1px;
}
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
